<script setup>
import { ref } from 'vue'

const tosDialog = ref(false)
defineExpose({ tosDialog })

const sections = [
  { icon: 'mdi-handshake', title: '1. Acceptance of Terms', body: 'By accessing and using the NightRiderz website and services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.' },
  { icon: 'mdi-account-group', title: '2. User Obligations', body: 'Users must be at least 13 years old, provide accurate account information, keep their account secure, avoid illegal use, and not harass or harm other users.' },
  { icon: 'mdi-security', title: '3. Privacy and Data Protection', body: 'We are committed to protecting your privacy and personal data. Our data practices are detailed in the Privacy Policy section of the Legal Notices.' },
  { icon: 'mdi-cart', title: '4. Premium Services', body: 'Premium features are available through a one-time payment. By purchasing, you agree to pay the presented fees. No refunds are provided except as required by law.' },
  { icon: 'mdi-license', title: '5. Intellectual Property', body: 'All NightRiderz content, including text, graphics, logos, and software, is protected by intellectual property rights. Do not copy, modify, or distribute it without permission.' },
  { icon: 'mdi-scale-balance', title: '6. Limitation of Liability', body: 'NightRiderz is provided “as is” without warranties. We are not liable for damages arising from use or inability to use the services.' },
  { icon: 'mdi-book-edit', title: '7. Modifications to Terms', body: 'We may modify these terms at any time. Continued use after changes constitutes acceptance of the updated terms.' },
]
</script>

<template><v-dialog v-model="tosDialog" max-width="720" scrollable>
    <v-card class="tos-card">
      <div class="tos-header-bg">
        <div class="tos-header">
          <div class="tos-title">Terms of Service</div>
          <v-btn icon variant="text" class="close-btn" @click="tosDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
      </div>
      <v-card-text class="tos-content">
        <div class="settings-tab-page">
          <p class="dialog-lead">These Terms of Service govern your use of the NightRiderz website and services.</p>
          <div class="section-list">
            <div v-for="item in sections" :key="item.title" class="section-row">
              <div class="section-body tos-row">
                <span class="tos-icon"><v-icon size="18">{{ item.icon }}</v-icon></span>
                <div><strong>{{ item.title }}</strong><p>{{ item.body }}</p></div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="tonal" @click="tosDialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog></template>

<style scoped>
.tos-header {
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  min-height:56px;
  padding:12px 16px}
.tos-title {
  font-size:1.05rem;
  font-weight:800;
  letter-spacing:.02em;
  text-transform:uppercase}
.dialog-lead {
  margin:0 0 14px;
  color:var(--mute);
  font-size:.86rem;
  line-height:1.45}
.tos-row {
  display:flex;
  align-items:flex-start;
  gap:12px}
.tos-icon {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  flex-shrink:0;
  width:36px;
  height:36px;
  border-radius:9px;
  background:var(--glass-strong)}
.tos-row strong {
  display:block;
  font-size:.9rem}
.tos-row p {
  margin:4px 0 0;
  color:var(--mute);
  font-size:.82rem;
  line-height:1.45}
</style>
